import { useContext } from "react";
import { DataRow } from "../DataRow";
import { TableRowContext } from "./TableRowContext";

/**
 * Gets the current row.
 * @returns The current row, if any.
 */
export function useTableRow(): DataRow<object> | null {
  const { row } = useContext(TableRowContext);
  return row;
}
